module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    attrs: {
      "src": _vm.imageUrl || _vm.noImageUrl,
      "alt": _vm.altText
    },
    on: {
      "error": _vm.onError
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6b34f7e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b34f7e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/image.vue
// module id = 843
// module chunks = 0